<p-card>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="ooMenuItemCanvases"
		dataKey="canvasKey"
		[globalFilterFields]="['ooCanvas.name', 'ooCanvas.displayName']"
		[rowHover]="true"
		[rows]="10"
		[showCurrentPageReport]="true"
		[rowsPerPageOptions]="[10, 25, 50]"
		responsiveLayout="scroll"
		[paginator]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<span class="p-float-label p-input-icon-left m-2 flex-grow-1">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search by canvas name or display name</label>
				</span>
				<p-button pRipple styleClass="p-button-warning p-button-raised m-2" (click)="sbReorderGroups.open()">
					<ng-template pTemplate="content">
						<fa-icon [icon]="['far', 'sort-shapes-down']" size="lg" class="ms-1"></fa-icon>
					</ng-template>
				</p-button>
				<p-button pRipple styleClass="p-button p-button-raised m-2" (click)="ooMenuItemCanvasNew()">
					<ng-template pTemplate="content">
						<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1"></fa-icon>
					</ng-template>
				</p-button>
			</div>
		</ng-template>
		<ng-template pTemplate="header" #header>
			<tr>
				<th>Mod Canvas</th>
				<th>Online</th>
				<th>Min Req'd</th>
				<th>Max Allowed</th>
				<th>Source</th>
				<th style="text-align: right"></th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-rec let-idx="index">
			<tr>
				<td>
					<div class="p-column-title">Mod Canvas</div>
					{{ rec.ooCanvas?.displayName || rec.ooCanvas?.name }}
				</td>
				<td>
					<span class="p-column-title">Online</span>
					<p-inputSwitch [(ngModel)]="rec.online" [readonly]="true"></p-inputSwitch>
				</td>
				<td>
					<span class="p-column-title">Min Req'd</span>
					{{ rec.min }}
				</td>
				<td>
					<span class="p-column-title">Max Allowed</span>
					{{ rec.max }}
				</td>
				<td>
					<span class="p-column-title">Source</span>
					{{ rec.source }}
				</td>
				<td style="text-align: right">
					<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="ooMenuItemCanvasSelected = rec">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'pencil']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
					<p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="ooMenuItemCanvasRemove(rec)">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'trash']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</p-card>

<focus-sidebar #sbReorderGroups header="Reorder Modifier Canvases" [showCloseIcon]="true" size="xxs" [dismissible]="false" (onClose)="onCanvasReorder()">
	<p-orderList *ngIf="ooMenuItemCanvases" [value]="ooMenuItemCanvases">
		<ng-template let-item pTemplate="item">
			<div>
				{{ item.ooCanvas.displayName || item.ooCanvas.name }}
			</div>
		</ng-template>
	</p-orderList>
</focus-sidebar>

<p-dialog
	*ngIf="ooMenuItemCanvasSelected"
	[(visible)]="ooMenuItemCanvasSelected"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw' }"
>
	<p-header>
		<div *ngIf="newOoMenuItemCanvas" class="h3">Add New Canvas Item</div>
		<div *ngIf="!newOoMenuItemCanvas" class="h3">Edit {{ ooMenuItemCanvasSelected.ooCanvas.displayName || ooMenuItemCanvasSelected.ooCanvas.name }}</div>
	</p-header>

	<div class="d-flex flex-column">
		<form #modifierForm="ngForm">
			<div class="mt-5">
				<span class="p-float-label">
					<p-dropdown
						id="canvasPick"
						name="canvasPick"
						placeholder="&nbsp;"
						[options]="canvasList"
						optionLabel="name"
						[autoDisplayFirst]="false"
						optionValue="canvasKey"
						name="canvasList"
						[(ngModel)]="ooMenuItemCanvasSelected.canvasKey"
						[style]="{ width: '100%' }"
						[filter]="true"
						filterBy="name, displayName"
						[virtualScroll]="canvasList?.length > 50"
						virtualScrollItemSize="30"
						appendTo="body"
					>
					</p-dropdown>
					<label for="canvasPick">Modifier Canvas</label>
				</span>
			</div>

			<div class="d-flex flex-row mt-4">
				<div class="d-flex flex-column">
					<div>Online</div>
					<p-inputSwitch name="onlineToggle" [(ngModel)]="ooMenuItemCanvasSelected.online" styleClass="me-2"></p-inputSwitch>
				</div>
				<div class="m-2">
					<span class="p-float-label">
						<p-inputNumber
							required
							name="modMin"
							id="modMin"
							[disabled]="ooMenuItemCanvasSelected.canvasKey < 10000"
							[(ngModel)]="ooMenuItemCanvasSelected.min"
							styleClass="m-2"
							[showButtons]="true"
							[min]="0"
							[max]="99"
						>
						</p-inputNumber>
						<label for="modMin" class="ms-2">Minimum Mods</label>
					</span>
				</div>
				<div class="m-2">
					<span class="p-float-label">
						<p-inputNumber
							name="modMax"
							id="modMax"
							[disabled]="ooMenuItemCanvasSelected.canvasKey < 10000"
							[(ngModel)]="ooMenuItemCanvasSelected.max"
							styleClass="m-2"
							[showButtons]="true"
							[min]="0"
							[max]="99"
						>
						</p-inputNumber>
						<label for="modMax" class="ms-2">Maximum Mods</label>
					</span>
				</div>
			</div>
			<div *ngIf="ooMenuItemCanvasSelected.canvasKey < 10000" class="d-flex">
				<div class="ms-auto descriptionText">POS canvas min/max cannot be edited here.</div>
			</div>
		</form>
	</div>

	<p-footer>
		<div class="d-flex justify-content-end">
			<app-record-control-footer
				[hideDelete]="true"
				[saveDisabled]="modifierForm.invalid"
				(onCancelChange)="ooMenuItemCanvasSelected = undefined; newOoMenuItemCanvas = false"
				(onSaveChange)="ooMenuItemCanvasSave(ooMenuItemCanvasSelected); ooMenuItemCanvasSelected = undefined"
			></app-record-control-footer>
		</div>
	</p-footer>
</p-dialog>
